<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
          <v-img
            alt="DealBook by HedgeCo Securities"
            class="shrink mr-2"
            contain
            :src="require('./assets/logo.png')"
            transition="scale-transition"
            width="160"
          />

      <v-spacer></v-spacer>

      <span class="mr-1"><v-btn color="primary" dark  class="mb-2" target="blank" :href="`mailto:dealbook@hedgecosecurities.com?subject=Send me information about HedgeCoSecurities`">Contact HedgeCoSecurities</v-btn></span>
    </v-app-bar>

    <v-content>
      <Dealbook/>
    </v-content>

  <v-footer
    dark
    padless
  >
    <v-card
      absolute
      class="flex"
      color="primary"
    >

      <v-card-text class="white--text text-center">
        Copyright - HedgeCoSecurities {{ new Date().getFullYear() }} <strong></strong>
      </v-card-text>
    </v-card>
  </v-footer>


  </v-app>
</template>

<script>
import Dealbook from './components/Dealbook';

export default {
  name: 'App',

  components: {
    Dealbook,
  },

  data: () => ({
    //
  }),
};
</script>
